import { NgModule } from '@angular/core';
import { DropdownListComponent } from './dropdown-list.component';
import { VoxelIconModule } from '@voxel/internet';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [DropdownListComponent],
  imports: [
    VoxelIconModule,
    CommonModule
  ],
  exports: [DropdownListComponent]
})
export class DropdownListModule { }
